import axios from 'axios';
import { vendorUrlRegexPath, withPimURL } from 'src/helpers/service';
import { FlashDiscountPeriodTypeResponse } from '../models/flash-discount';

const periodColors = [
  // bgColor, textColor
  ['#F3FAFF', 'black'],
  ['#FCDBE4', 'black'],
];

export const getFlashDiscountPeriodTypes = async () => {
  return axios
    .get<(FlashDiscountPeriodTypeResponse & { colors: [string, string] })[]>(withPimURL(vendorUrlRegexPath('/flash-discount/:vendorId/period-types')))
    .then((res) => res.data)
    .then((res) =>
      res.map((v, vIdx) => ({
        ...v,
        colors: periodColors?.[vIdx] || periodColors?.[0],
      })),
    );
};
